/** HTTP header name for member CustID (UserInfo.ID). */
export const CUST_ID_HEADER = 'x-real-ld';

let requestCustId: number | undefined;

const get3CharRandom = () => {
	let randomStr = '';
	for (let i = 0; i < 20; i++) {
		randomStr = Math.random().toString(36).slice(2, 5);
		if (randomStr.length === 3 && !/^\d+$/.test(randomStr)) {
			return randomStr;
		}
	}
	return `a${randomStr.slice(0, 2)}`;
};

const get6CharID = () => {
	const randomStr = get3CharRandom();
	const timeStr = Date.now().toString(36).slice(-3); // 拿 3 碼時間末尾
	return randomStr + timeStr;
};

const randomId = get6CharID();

export const setRequestCustId = (custId: number | undefined) => {
	requestCustId = custId;
};

export const getRequestCustId = () => requestCustId;

export const custIdHeader = (): Record<string, string> =>
	requestCustId != null && requestCustId > 0
		? { [CUST_ID_HEADER]: String(requestCustId) + '-' + randomId }
		: { [CUST_ID_HEADER]: randomId };
